import React from "react";

import { Caption } from "../../styles";
import { formatObservedAt } from "../../utils/format";

export const ObservedAt: React.FC<{ observedAt: string }> = ({
  observedAt,
}) => <Caption>Observed {formatObservedAt(observedAt)}</Caption>;
